import {  OrgResultsContainerProps } from "../types/orgResults.types";
import { OrgResultsConst } from '../utils/constants/orgResults';


const OrgResultsReducers = (state:  OrgResultsContainerProps, action: any):  OrgResultsContainerProps => {
    const initState = {
      ...state,
    };
    switch (action.type) {
        case OrgResultsConst.FETCH_USER_LIST:
          let defaultUData = state.defaultUserList;
          if(!defaultUData && !action.term){
              defaultUData = action.payload;
          }
          return {
              ...state,
              defaultUserList: defaultUData,
              usersList: action.payload
          }
        case OrgResultsConst.PUSH_DEFAULT_USER_LIST:
          return {
            ...state,
            usersList: state.defaultUserList
          }
        case OrgResultsConst.UPDATE_ORG_RESULTS:
          return {
            ...state,
            selectedValue: action.selectedValue,
            goalData: action.goalData,
            teamProgress: action.teamProgress,
            daysleft: action.daysleft,
            dateAsOf: action.dateAsOf,
            forData: action.forData,
            objKey: action.objKey,
            directReporteeLists: action.directReporteeLists,
            QTDResults: action.QTDResults,
            pQuaterName: action.pQuaterName,
            cQuaterName: action.cQuaterName,
          }
        case OrgResultsConst.UPDATE_POPUP_DATA:
          let pData ;
          if(action.offset > 0){
            pData = [...state.popupData.data, ...action.payload];
          } else{
            pData = action.payload;
          }
          return {
            ...state,
            popupData: {
              isAllFetched: action.isAllFetched,
              membersCount:  action.membersCount,
              data: pData
            }
          }
        default:
            return state;
    }
}

export default OrgResultsReducers;